/**
 * Write / clear the `order_id` query param on `window.location`. Used by
 * PackPage to switch between pack view and reveal view while keeping the
 * URL shareable/refreshable (F5 on reveal stays on reveal).
 * Mirrors `setGameIdInURL`.
 */
export function setOrderIdInURL(orderId: string | null): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  const current = url.searchParams.get('order_id');
  if (orderId) {
    if (current === orderId) return;
    url.searchParams.set('order_id', orderId);
  } else {
    if (current === null) return;
    url.searchParams.delete('order_id');
  }
  window.history.replaceState(null, '', url);
}

export function getOrderIdFromURL(): string | null {
  if (typeof window === 'undefined') return null;
  const url = new URL(window.location.href);
  const raw = url.searchParams.get('order_id');
  return raw && raw.length > 0 ? raw : null;
}
